export const computeSortingValue = (value: 'asc' | 'desc'): 'asc' | 'desc' => {
  return value === 'asc' ? 'desc' : 'asc';
};

export const parseSort = (sort: readonly string[]): Record<string, 'asc' | 'desc'> => {
  return sort.reduce(
    (sorting: Record<string, 'asc' | 'desc'>, item: string): Record<string, 'asc' | 'desc'> => {
      const [targetColumn, direction] = item.split(',');

      if (direction !== 'asc' && direction !== 'desc') {
        return sorting;
      }

      return { ...sorting, [targetColumn]: direction };
    },
    {},
  );
};
